<script lang="ts">
  import { onMount } from 'svelte'

  type Props = {
    min: number
    max: number
    step: number
    value?: number
    tickStep?: number
    hideTicks?: boolean
    defaultValue?: number
  }

  let {
    tickStep,
    hideTicks = false,
    value = $bindable(),
    ...props
  }: Props = $props()

  let ticks = $state<number[]>([])

  onMount(() => {
    const step = tickStep ?? props.step
    const steps = Math.floor((props.max - props.min) / step) + 1
    ticks = !hideTicks
      ? Array.from(
        { length: steps },
        (_, index) => props.min + index * step,
      )
      : []
  })
</script>

<div class="container">
  <input
    {...props}
    class="slider"
    type="range"
    bind:value
  />
  <div class="ticks">
    {#each ticks as tick (tick)}
      <div
        style:left="{((tick - props.min) / (props.max - props.min))
          * 100}%"
        class={['tick', !hideTicks]}
        data-value={tick}
      ></div>
    {/each}
  </div>
</div>

<style lang="scss">
    .container {
        width: 100%;
        position: relative;
        min-height: 1rem;
        display: flex;
        align-items: center;

        .slider {
            appearance: none;
            -webkit-appearance: none;
            width: calc(100%);
            height: 0.375rem;
            background: var(--slider-background);
            border-radius: 0.25rem;
            margin: 0;
            outline: none;

            &::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                min-width: 1rem;
                min-height: 1rem;
                width: 1rem;
                height: 1rem;
                border-radius: 1rem;
                background: var(--slider-thumb-background);
                cursor: pointer;
                position: relative;
                z-index: 1;
            }

            &::-moz-range-thumb {
                border-radius: 1rem;
                min-width: 1rem;
                min-height: 1rem;
                width: 1rem;
                height: 1rem;
                background: var(--slider-thumb-background);
                cursor: pointer;
                position: relative;
                z-index: 1;
            }

            &:focus {
                &::-webkit-slider-thumb {
                    outline: 1px solid var(--stroke);
                    outline-offset: 2px;
                }
            }
        }
    }

    .ticks {
        width: calc(100% - 0.875rem);
        position: absolute;
        left: 0;
        right: 0;
        top: 0.3rem;
        bottom: 0;
        height: 0.375rem;
        margin: 0 auto;
        pointer-events: none;

        .tick {
            position: absolute;
            width: 1px;
            height: 100%;
            background-color: var(--slider-tick-background);
            transform: translateX(-50%);

            &:first-child,
            &:last-child {
                display: none;
            }
        }
    }
</style>
